module.exports = __webpack_public_path__ + "static/media/mblink.8c7a6027.ico";